import React, { Component } from 'react';
import { Col, Row, Tab, Nav, NavItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import {openChapters, toArray} from '../common/util';
import RosterDivision from './RosterDivision';
import { fetchDivisions } from '../redux/actions';
import {chapterMemberSelector, chapterSelector, rankSelector, userSelector} from "../redux/selectors";

class Roster extends Component {
    componentDidMount() {
        for (let chapter of openChapters(this.props.chapters)) {
            this.props.getRoster(chapter.id);
        }
        document.title = "Addiction | Roster";
    }
    // sortMembers(members, division, chapter) {
    //     let divisionMembers = [];
    //     if (members && division) {
    //         for (let member of members) {
    //             if (member.divisionId === division.id && member.chapter === chapter.id)
    //                 divisionMembers.push(member)
    //         }
    //     }
    //     return divisionMembers;
    // }
    render() {
        return (
            <div>
                <h1>Roster</h1>
                <div className="panel">
                    <Tab.Container id="roster" defaultActiveKey="0-roster">
                        <Row className="clearfix">
                            <Col xs={18} md={12}>
                                <Nav bsStyle="pills">
                                    {
                                        openChapters(this.props.chapters).map((chapter, i) => (
                                            <NavItem eventKey={`${i}-roster`} key={`${i}-roster`}><h3>{chapter.game.title}</h3></NavItem>
                                        ))
                                    }
                                </Nav>
                            </Col>
                            <Col xs={18} md={12}>
                                <Tab.Content animation>
                                    { openChapters(this.props.chapters).map((chapter, i) => (
                                        <Tab.Pane eventKey={`${i}-roster`} key={`${i}-roster`}>
                                            { toArray(this.props.divisions)
                                                .filter(division => division.chapter === chapter.id)
                                                .filter(division => division.parent === null)
                                                .sort((a, b) => (a.order - b.order))
                                                .map((division) => (
                                                <ul className="roster-list" key={`${division.id}-division`}>
                                                    <RosterDivision
                                                        division={division}
                                                        ranks={this.props.ranks}
                                                        users={this.props.users}
                                                        chapterMembers={this.props.chapterMembers}
                                                        divisions={this.props.divisions}
                                                    />
                                                </ul>
                                            ))
                                            }
                                        </Tab.Pane>
                                    ))
                                    }
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    chapters: chapterSelector(state),
    chapterMembers: chapterMemberSelector(state),
    divisions: state.divisions.data,
    ranks: rankSelector(state),
    users: userSelector(state)
});

const mapDispatchToProps = (dispatch) => ({
    getRoster: (chapter) => dispatch(fetchDivisions(chapter)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Roster);


// WEBPACK FOOTER //
// ./src/Roster/Roster.js